<template>
  <el-tabs v-model="tabPaneVal" type="border-card" @tab-click="handleClick">
    <el-tab-pane label="网商支付" name="merchantList">
      <merchantList ref="merchantListRef" />
    </el-tab-pane>
    <el-tab-pane label="凭证支付" name="creditProof">
      <creditProofList ref="creditProofRef" />
    </el-tab-pane>
  </el-tabs>
</template>
<script>
  import merchantList from './merchantList'
  import creditProofList from './creditProofList'
  export default {
    name: "Template",
    components:{
      merchantList,
      creditProofList
    },
    data() {
      return {
        tabPaneVal:'merchantList',
        /**
         * data 中只定义变量，赋值放在 created() 中
         */
        loading: false,
        tableData: [],
        errorData: [],
        parentData: {},
        modelEditFlag: false,
        modalTitle: "编辑",
        dialogTableVisible: false,
        listQuery: {
          pageNum: 1,
          pageSize: 20,
          sortField: "",
          sortType: "",
          total: 0
        },
        // 机构列表
        branchList: this.$store.state.components.branchList
      }
    },

    created() {
      /**
       * 下拉选项用“parentData”存放，便于向子组件传递
       */
    },
    methods: {
      handleClick(tab, event) {
      // this[`is${tab.name}Show`] = true;
        this.$nextTick(() => {
        this.$refs[`${tab.name}Ref`].findList() ;
      })
    },
    }
  };
</script>
<style scoped>
  .btnPicture {
    min-width: 140px;
    line-height: 40px;
    background: #1890FF;
    border-radius: 4px;
    padding: 10px 20px;
    font-family: PingFang SC;
    color: #FFFFFFFF;
    cursor: pointer;
  }
</style>
